import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * Setting to control browser ID tracking.
 * This is a global configuration setting without segmentation, product area or user type targeting.
 */
export const FE_RECORD_BROWSER_ID_TRACKING_072425 = configuration({
  name: "FE_RECORD_BROWSER_ID_TRACKING_072425",
  // Using SessionToken as the most generic identifier for global setting
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  defaultValue: false,
  productArea: "SEO",
});
